import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashService } from '@helpers/splash/splash.service';

/**
 * Componente de pantalla de carga (splash screen) que se muestra al iniciar la aplicación.
 * La visibilidad del splash es controlada por SplashService y se oculta automáticamente
 * cuando la navegación de rutas termina.
 *
 * @Input bgClass - Clase CSS de fondo (por defecto: 'bg-transparent')
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-splash',
  imports: [CommonModule],
  template: `
    @if (splashService.isVisible()) {
      <div [attr.class]="divClasses()">
        <div
          class="w-[30rem] h-[30rem] flex flex-col justify-center items-center"
        >
          <h1 class="text-4xl font-extrabold mb-2 text-primary-500">
            Mensajería Dinámica - MUR
          </h1>
          <img
            class="mb-2 w-[20rem] h-[20rem] rounded-full"
            src="assets/images/mur-logo.png"
            alt="splash"
          />
          <span
            class="animate-ping animate-duration-[1500ms] text-sm text-primary-200"
          >
            Cargando...</span
          >
        </div>
      </div>
    }
  `
})
export class AppSplashComponent {
  /**
   * Servicio que controla la visibilidad del splash screen.
   * El splash se oculta automáticamente cuando termina la navegación de rutas.
   */
  protected splashService = inject(SplashService);

  /**
   * Clase CSS de fondo del splash (por defecto: 'bg-transparent')
   */
  bgClass = input('bg-transparent');

  /**
   * Propiedades CSS computadas dinámicamente
   */
  protected readonly divClasses = computed(
    () =>
      `fixed inset-0 flex justify-center items-center font-bold ${this.bgClass()} pointer-events-none z-50`
  );
}
